import { Tooltip, TooltipProps } from '@toggle/design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { useTouchDevice } from '@/stores/MediaQueryStore';

export const TooltipContainer = (
  props: Omit<TooltipProps, 'closeLabel' | 'isTouchDevice'>
) => {
  const isTouchDevice = useTouchDevice();
  const { t } = useTranslation('common');
  return (
    <Tooltip
      {...props}
      closeLabel={t('tapToClose')}
      isTouchDevice={isTouchDevice}
    >
      {props.children}
    </Tooltip>
  );
};
